// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accountFeedback{font-weight:bold}.ubiAccountRefreshBtn{cursor:pointer;color:#000;font-weight:bold;margin-left:10px}", ""]);
// Exports
module.exports = exports;
